import "./DeviceTile.scss";

import { Transition } from "@headlessui/react";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

import { ButtonLink } from "@/components/Interface/Button/Button";
import { FCC } from "@/types.ts";

export interface DeviceTileProps {
  icon?: JSX.Element;
  navigationTarget?: string;
  disableForPending?: boolean;
  className?: string;
  buttonText?: string;
}
interface TestableDeviceTileProps extends DeviceTileProps {
  dataTestid: string;
}

export const DeviceTile: FCC<TestableDeviceTileProps> = ({
  navigationTarget,
  icon,
  children,
  dataTestid,
  className,
  buttonText,
}) => {
  const { t } = useTranslation("portal");

  return (
    <div
      data-testid="device-tile"
      className={clsx(className, "tile-container")}
    >
      <Transition
        appear={true}
        show={true}
        enter="transition-opacity ease-linear duration-150"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity ease-linear duration-150"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div className="tile" data-testid={dataTestid}>
          <div className="tile-watermark-container">{icon}</div>
          <div className="content-container">
            {children}
            {navigationTarget && (
              <ButtonLink
                variant="primary"
                fullWidth
                to={navigationTarget}
                className="mt-auto"
              >
                {buttonText || t("layout.tiles.manage")}
              </ButtonLink>
            )}
          </div>
        </div>
      </Transition>
    </div>
  );
};
